module.exports = __webpack_public_path__ + "static/Abacus Data Analyser HR Dashboard Saläranalyse-c631e7693b2d3b0be95b2233e6f3dbb3.jpg";